var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('h1',[_vm._v("HOLA YEEKO. BIENVENIDO OTRA VEZ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }